import { render, staticRenderFns } from "./Activity5_1.vue?vue&type=template&id=a84918ca&scoped=true&"
import script from "./Activity5_1.vue?vue&type=script&lang=js&"
export * from "./Activity5_1.vue?vue&type=script&lang=js&"
import style0 from "./Activity5_1.vue?vue&type=style&index=0&id=a84918ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84918ca",
  null
  
)

export default component.exports